import { ReactElement } from 'react';
import { makeStyles } from 'tss-react/mui';

import { Card } from './Card';

export interface IStatsProps {
  children: ReactElement | ReactElement[];
}

export function Stats({ children }: IStatsProps): ReactElement | null {
  const { classes } = useStyles();

  return (
    <Card className={classes.root} wrapClassName={classes.wrap}>
      {children}
    </Card>
  );
}

const useStyles = makeStyles()(theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      background: 'transparent',
      borderRadius: 0,
    },
  },
  wrap: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
    gap: theme.spacing(2),
    scrollbarWidth: 'none',

    [theme.breakpoints.up('sm')]: {
      borderRadius: 12,
      padding: theme.spacing(3.75, 6),
    },

    [theme.breakpoints.down('sm')]: {
      overflowX: 'auto',
      marginRight: theme.spacing(-4),
      padding: 0,
      borderRadius: 0,
      paddingRight: theme.spacing(4),
      paddingLeft: theme.spacing(4),
      marginLeft: theme.spacing(-4),
      background: 'transparent',
    },
  },
}));
